import { Directive } from '@angular/core';

import { CdkPortal } from '@angular/cdk/portal';

@Directive({ selector: '[a3l-ui-tab-title]' })
export class TabTitleDirective extends CdkPortal {
  //
}
